import React from 'react';
import { CoachCard } from '../../components/CoachCard';
const coaches = [{
  name: 'Shane Merem',
  role: 'Owner / Team Storm Coach',
  bio: 'Coach Shane instills grit, confidence, determination, and discipline in every student. He focuses on physical fitness and building strong character both on and off the mat.',
  comingSoon: true
}, {
  name: 'Megan Merem',
  role: 'Chief Instructor',
  bio: 'A two-time USA National Sparring Champion who has been training since age 3. Coach Megan creates a friendly but firm learning environment where students thrive.',
  comingSoon: true
}, {
  name: 'Michael Jacobs',
  role: 'Instructor',
  bio: 'A USAT National Gold Medalist, Coach Michael brings high-level competitive experience and technical precision to his classes.',
  comingSoon: true
}];
export function AboutCoaches() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-452">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-453">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-454">
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-455">Meet Our Team</h2>
          <p className="text-lg text-gray-warm" data-id="element-456">
            Get to know the talented individuals behind Storm Taekwondo.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-457">
          {coaches.map((coach, idx) => <CoachCard key={idx} name={coach.name} role={coach.role} bio={coach.bio} comingSoon={coach.comingSoon} data-id="element-458" />)}
        </div>
      </div>
    </section>;
}